import React from 'react';

import PropTypes from 'prop-types';

import { Badge } from '@/components/ui/badge';
import { BADGE_COLORS } from './colors';

const Tag = ({ color, name, className = '' }) => (
  <Badge className={`${BADGE_COLORS[color]} ${className}`}>
    <span className="truncate">{name}</span>
  </Badge>
);

Tag.propTypes = {
  color: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Tag;
